import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, isRef as _isRef, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c213d66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "user d-flex user-mobile mb-4"
}
const _hoisted_4 = { class: "user-title-mobile" }
const _hoisted_5 = { class: "fs-7 mb-0 text-break col-md-9" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = {
  key: 2,
  class: "user-container mb-4 d-flex justify-content-between align-items-center"
}
const _hoisted_8 = { class: "user d-flex" }
const _hoisted_9 = { class: "fs-7 mb-0" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 3,
  class: "last-comment position-relative"
}
const _hoisted_13 = {
  key: 0,
  class: "bg-gray position-absolute rounded-pill d-inline-block px-2 fs-7"
}
const _hoisted_14 = {
  key: 4,
  class: "d-flex"
}
const _hoisted_15 = { class: "last-comment position-relative w-100" }
const _hoisted_16 = {
  key: 0,
  class: "bg-gray position-absolute rounded-pill d-inline-block px-2 fs-7"
}
const _hoisted_17 = {
  key: 0,
  class: "fw-bold fs-7 text-danger me-3 text-nowrap 2"
}
const _hoisted_18 = {
  key: 1,
  class: "text-white bg-danger px-4 py-2 me-3 text-nowrap"
}
const _hoisted_19 = {
  key: 2,
  class: "text-white bg-danger px-4 py-2 me-3 text-nowrap"
}
const _hoisted_20 = {
  key: 3,
  class: "text-white bg-black px-4 py-2 me-3 text-nowrap"
}
const _hoisted_21 = {
  key: 4,
  class: "bg-base-gray px-4 py-2 me-3 text-nowrap"
}
const _hoisted_22 = { class: "d-flex" }
const _hoisted_23 = { class: "fs-7 fw-bold text-break w-100" }
const _hoisted_24 = { class: "comment__content ms-3 position-relative w-100 text-break break-spaces" }

import { computed, ComputedRef, PropType, ref, watchEffect } from 'vue'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/ja'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'

import { ROOT_STORE } from '@/store/constants'
import Category from '@/components/category/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import Avatar from '@/components/avatar/index.vue'
import { ChangeTime } from '@/constants/datepicker'
import TargetTag from '@/components/target-tag/index.vue'
import { partnerChatDisplayName } from '@/constants/common.ts'
import ChatStar from './ChatStar.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Object as PropType<{
      display_name: string
      family_name: string
      given_name: string
      id: string
      post_id: string
      status: number
      post_type: number
      management_no: string
      title: string
      image_url: string
      user_type: number | string
      close: boolean
      unread_chat_count: number
      latest_content: {
        my_content: boolean
        content: string
        image_url: string
        display_name: string
        user_type: number | string
        updated_at: string
        management_no: string
      }
      end_date: string
      closed?: boolean
      post_published?: boolean
      star?: boolean
    }>,
    required: true,
  },
  isAdmin: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update-star'],
  setup(__props, { emit }) {

const props = __props

const store = useStore()


dayjs.locale('ja')

dayjs.extend(relativeTime)

const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const router = useRouter()
const route = useRoute()
const checkHideBtn = ref<boolean>(false)



watchEffect(() => {
  if (props.data?.post_id) {
    checkHideBtn.value = [
      `/community/communities/${route.params.id}/alumnus/${route.params?.managementNo}/chat-list`,
      `/community/communities/${route.params.id}/community-users/${route.params?.managementNo}/chat-list`,
    ].includes(route.path)
  }
})

const checkDisplayButton = (data: any) => {
  if (checkHideBtn.value && (!dayjs().isBefore(dayjs(data?.end_date).add(1, 'day')) || data?.post_type) && data.closed) return false
  else if (props?.isAdmin || ((dayjs().isBefore(dayjs(data?.end_date).add(1, 'day')) || !data?.post_type) && !data.closed)) return true
}

const handleClick = (): void => {
  if (!props.data?.post_type) {
    router.push(
      props?.isAdmin
        ? `/${route.path.split('/')[1]}/communities/${route.params.id}/admin/direct_chat/${props.data?.id}`
        : `/${route.path.split('/')[1]}/communities/${route.params.id}/direct_chat/${props.data?.id}`
    )
    return
  }
  if (props.data?.post_id) {
    if (props?.data?.chat_by_admin) {
      router.push(
        props?.isAdmin
          ? `/${route.path.split('/')[1]}/communities/${route.params.id}/posts/${props.data?.post_id}/admin/chats/${props.data?.id}`
          : `/${route.path.split('/')[1]}/communities/${route.params.id}/posts/${props.data?.post_id}/chats/${props.data?.id}`
      )
    } else {
      if (route.path === `/community/communities/${route.params.id}/alumnus/${route.params?.managementNo}/chat-list`)
        router.push(`/${route.path.split('/')[1]}/communities/${route.params.id}/alumnus/${route.params?.managementNo}/posts/${props.data?.post_id}/chats/${props.data?.id}`)
      else if (route.path === `/community/communities/${route.params.id}/community-users/${route.params?.managementNo}/chat-list`)
        router.push(
          `/${route.path.split('/')[1]}/communities/${route.params.id}/community-users/${route.params?.managementNo}/posts/${props.data?.post_id}/chats/${props.data?.id}`
        )
      else {
        router.push(
          props?.isAdmin
            ? `/${route.path.split('/')[1]}/communities/${route.params.id}/posts/${props.data?.post_id}/admin/chats/${props.data?.id}`
            : `/${route.path.split('/')[1]}/communities/${route.params.id}/posts/${props.data?.post_id}/chats/${props.data?.id}`
        )
      }
    }
  } else {
    router.push(
      props?.isAdmin
        ? `/${route.path.split('/')[1]}/communities/${route.params.id}/admin/direct_chat/${props.data?.id}`
        : `/${route.path.split('/')[1]}/communities/${route.params.id}/direct_chat/${props.data?.id}`
    )
  }
}

const handleDetail = (status: number, user_type: string, management_no): void => {
  if (!props.isAdmin || [2, 3].includes(status) || user_type === 'community_admin') {
    return
  }
  if (user_type === 'alumni') {
    router.push(`/community/communities/${router.currentRoute.value.params?.id}/alumnus/${management_no}/edit`)
    return
  }
  router.push(`/community/communities/${router.currentRoute.value.params?.id}/community-users/${management_no}/edit`)
}

const renderStatusHtml = (onTop = true): string => {
  // Return an empty string if it's a mobile device
  if (isMobile.value) return ''

  // Extract status and data from props for easier access
  const { status, closed, end_date, post_published } = props.data ?? {}

  if (onTop) {
    if (status === 1) {
      // Condition for status 1
      if (!closed && end_date && !dayjs().isBefore(dayjs(end_date).add(1, 'day'))) {
        return `<span class="text-white bg-black px-4 py-2">${translate('end')}</span>`
      }
    } else if (status === 2 || status === 3) {
      // Conditions for status 2 and 3
      const text = status === 2 ? translate('SM10withdrawn') : translate('SM10stopped')
      return `<span class="text-white bg-danger px-4 py-2">${text}</span>`
    }

    // Condition for closed
    if (closed) {
      return `<span class="text-white bg-black px-4 py-2">${translate('end')}</span>`
    }

    // Condition for unpublished post
    // post_published can be true, false or undefined
    if (post_published === false) {
      return `<span class="bg-base-gray px-4 py-2">${translate('private')}</span>`
    }
  } else if (status === 1 && !closed && end_date && post_published !== false && dayjs().isBefore(dayjs(end_date).add(1, 'day'))) {
    // Additional condition when not on top
    return `<span class="fw-bold fs-7 text-danger ms-2 me-3 text-nowrap">${dayjs(end_date).format('MM/DD')}まで会話できます</span>`
  }

  return ''
}

const syncedStar = computed({
  get() {
    return !!props.data?.star
  },
  set(newValue: boolean) {
    emit('update-star', props.data?.id, newValue)
  },
})

const showChatStar = computed(() => props?.isAdmin && route.meta.screenId !== 'OE70')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (renderStatusHtml())
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "position-absolute position-drawn",
          innerHTML: renderStatusHtml()
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['p-3 p-lg-4 shadow rounded-4 bg-white mb-3 mb-lg-5', __props.data?.status !== 1 ? 'not-normal opacity-not-normal' : ''])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['title position-relative pb-2 mb-2', __props.data?.status !== 1 ? 'opacity-not-normal' : ''])
      }, [
        (__props.data?.post_type)
          ? (_openBlock(), _createBlock(Category, {
              key: 0,
              content_type: __props.data?.post_type
            }, null, 8, ["content_type"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(['d-flex align-items-center mb-3', !__props.data?.post_id && _unref(route).query?.tab === 'direct' ? 'justify-content-end' : 'justify-content-between'])
        }, [
          (__props.data?.post_id)
            ? (_openBlock(), _createElementBlock("h3", {
                key: 0,
                class: _normalizeClass(['fw-bold fs-5 lh-base text-break cursor-pointer col-md-9']),
                onClick: handleClick
              }, _toDisplayString(__props.data?.title), 1))
            : (_unref(route).query?.tab !== 'direct')
              ? (_openBlock(), _createElementBlock("h3", {
                  key: 1,
                  class: "fw-bold fs-5 lh-base text-break cursor-pointer col-md-9",
                  onClick: handleClick
                }, _toDisplayString(_unref(translate)('SM10TitleNotPostId')), 1))
              : _createCommentVNode("", true),
          (_unref(showChatStar))
            ? (_openBlock(), _createBlock(ChatStar, {
                key: 2,
                star: _unref(syncedStar),
                "onUpdate:star": _cache[0] || (_cache[0] = ($event: any) => (_isRef(syncedStar) ? (syncedStar).value = $event : null)),
                "chatroom-id": __props.data.id
              }, null, 8, ["star", "chatroom-id"]))
            : _createCommentVNode("", true)
        ], 2),
        (_unref(isMobile))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(Avatar, {
                is_deleted_in_30_days: __props.data?.is_deleted_in_30_days,
                user_image_url: __props.data?.image_url,
                size: 'small',
                userType: __props.data?.user_type
              }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h4", _hoisted_5, _toDisplayString(_unref(translate)('SM10partner')), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(UserAliasIcon, {
                    userType: __props.data?.user_type
                  }, null, 8, ["userType"]),
                  _createElementVNode("p", {
                    class: _normalizeClass([[2, 3].includes(__props.data?.status) || __props.data?.user_type === 'community_admin' ? '' : 'cursor-pointer', "fs-7 fw-bold text-break w-100"]),
                    onClick: _cache[1] || (_cache[1] = () => handleDetail(__props.data?.status, __props.data?.user_type, __props.data?.management_no))
                  }, _toDisplayString(_unref(partnerChatDisplayName)(__props.data, __props.isAdmin)), 3)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _createVNode(Avatar, {
                    is_deleted_in_30_days: __props.data?.is_deleted_in_30_days,
                    user_image_url: __props.data?.image_url,
                    size: 'small',
                    userType: __props.data?.user_type
                  }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h4", _hoisted_9, _toDisplayString(_unref(translate)('SM10partner')), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(UserAliasIcon, {
                      userType: __props.data?.user_type
                    }, null, 8, ["userType"]),
                    _createElementVNode("p", {
                      class: _normalizeClass([[2, 3].includes(__props.data?.status) || __props.data?.user_type === 'community_admin' ? '' : 'cursor-pointer', "fs-7 fw-bold text-break w-100"]),
                      onClick: _cache[2] || (_cache[2] = () => handleDetail(__props.data?.status, __props.data?.user_type, __props.data?.management_no))
                    }, _toDisplayString(_unref(partnerChatDisplayName)(__props.data, __props.isAdmin)), 3)
                  ])
                ])
              ]),
              (renderStatusHtml(false))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    innerHTML: renderStatusHtml(false)
                  }, null, 8, _hoisted_11))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (__props.data?.latest_content)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(translate)('SM10lastRemarks')), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_unref(isMobile))
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (__props.data?.latest_content)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(translate)('SM10lastRemarks')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                (!__props.data?.closed && __props.data?.post_published != false && __props.data?.status === 1 && __props.data?.end_date && _unref(dayjs)().isBefore(_unref(dayjs)(__props.data?.end_date).add(1, 'day')))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(dayjs)(__props.data?.end_date).format('MM/DD')) + "まで会話できます ", 1))
                  : (__props.data?.status === 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(translate)('SM10withdrawn')), 1))
                    : (__props.data?.status === 3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(translate)('SM10stopped')), 1))
                      : (
                (!__props.data?.closed && __props.data?.status === 1 && __props.data?.end_date && !_unref(dayjs)().isBefore(_unref(dayjs)(__props.data?.end_date).add(1, 'day'))) || (__props.data.closed && ![2, 3].includes(__props.data?.status))
              )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(translate)('end')), 1))
                        : (__props.data?.post_published == false)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(translate)('private')), 1))
                          : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (__props.data?.latest_content)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['comment mb-4', __props.data?.status !== 1 ? 'opacity-not-normal' : ''])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(['d-flex w-100 ', __props.data?.latest_content?.my_content ? 'revert' : ''])
            }, [
              _createElementVNode("div", null, [
                (!__props.data?.latest_content?.my_content)
                  ? (_openBlock(), _createBlock(Avatar, {
                      key: 0,
                      is_deleted_in_30_days: __props.data?.latest_content?.is_deleted_in_30_days,
                      user_image_url: __props.data?.latest_content?.image_url,
                      userType: __props.data?.latest_content?.user_type
                    }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(['w-100 ', __props.data?.latest_content?.my_content ? 'revert me-4' : ''])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([__props.data?.latest_content?.my_content ? 'd-flex justify-content-end' : ''])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['comment__title w-100 d-flex justify-content-between', __props.data?.latest_content?.my_content ? 'justify-content-end flex-row-reverse' : ''])
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(UserAliasIcon, {
                        userType: __props.data?.latest_content?.user_type
                      }, null, 8, ["userType"]),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(partnerChatDisplayName)(__props.data?.latest_content, __props.isAdmin)), 1)
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_unref(ChangeTime)(__props.data?.latest_content?.updated_at)), 1)
                  ], 2)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass([__props.data?.latest_content?.my_content ? 'd-flex justify-content-end' : ''])
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(TargetTag, {
                      data: __props.data?.latest_content?.content,
                      class: _normalizeClass([__props.data?.status !== 1 ? 'disable' : ''])
                    }, null, 8, ["data", "class"])
                  ])
                ], 2)
              ], 2)
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      (checkDisplayButton(__props.data))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([
          'd-flex justify-content-lg-end align-items-center justify-content-center',
          __props.data?.status !== 1 ? 'opacity-not-normal' : '',
          (_unref(route).path === `/community/communities/${_unref(route).params.id}/community-users/${_unref(route).params?.managementNo}/chat-list` && !__props.data.chat_by_admin) ||
          (_unref(route).path === `/community/communities/${_unref(route).params.id}/alumnus/${_unref(route).params?.managementNo}/chat-list` && !__props.data.chat_by_admin)
            ? 'd-none'
            : '',
        ])
          }, [
            _createVNode(Button, {
              title: _unref(translate)('SM10talk'),
              type: 'secondary',
              disabled: (__props.data.closed || __props.data?.status !== 1) && !__props.isAdmin,
              unread_count: __props.data?.unread_chat_count,
              onClick: handleClick
            }, null, 8, ["title", "disabled", "unread_count"])
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})